import BlogArticleLayout from '@/components/feature/BlogArticleLayout';

export default function FornecedoresPage() {
  return <BlogArticleLayout slug="fornecedores-confiaveis-hoobuy" />;
}